import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {
  BaseApiTemplateService,
  Core2Config,
  BasicApiResponseModel,
  ApiVisa
} from '../../shared';
import {IntercompanyContainerModel} from '../../../../../../models/aggregates/intercompany';
import { Observable } from "rxjs";


@Injectable({
  providedIn: 'root'
})
export class IntercompanyService extends BaseApiTemplateService<IntercompanyContainerModel> {

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX +  'intercompany';
    this.endpoint_path =  Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX+'intercompany';
    this.httpClient = http;
  }

  // intercompany transaction from Sales Invoice to Purchase invoice
  fromSalesInvToPurchaseInv(payload:any, visa: ApiVisa): Observable<BasicApiResponseModel<any>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path + "/sales-invoice-to-purchase-invoice";
    }
    const httpOptions = {
      headers: new HttpHeaders({
        authorization: payload.authKey,
        tenantCode: payload.tenantCode,
        appId: payload.appletCode, 
      })
    }
    
    let body = {
      guids: payload.guids
    }
    
    return this.httpClient.post<BasicApiResponseModel<any>>(
      this.apiUrl,
      body,
      httpOptions
    );
  }

  // intercompany transaction from Purchase Order to Sales Order
  fromPurchaseOrderToSalesOrder(payload:any, visa: ApiVisa): Observable<BasicApiResponseModel<any>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path + "/purchase-order-to-sales-order";
    }
    const httpOptions = {
      headers: new HttpHeaders({
        authorization: payload.authKey,
        tenantCode: payload.tenantCode,
        appId: payload.appletCode, 
      })
    }

    let body = {
      guids: payload.guids
    }

    return this.httpClient.post<BasicApiResponseModel<any>>(
      this.apiUrl,
      body,
      httpOptions
    );
  }

  // intercompany transaction from Sales Invoice to Purchase GRN
  fromSalesInvToPurchaseGRN(payload:any, visa: ApiVisa): Observable<BasicApiResponseModel<any>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path + "/sales-invoice-to-purchase-grn";
    }
    const httpOptions = {
      headers: new HttpHeaders({
        authorization: payload.authKey,
        tenantCode: payload.tenantCode,
        appId: payload.appletCode, 
      })
    }

    let body = {
      guids: payload.guids
    }

    return this.httpClient.post<BasicApiResponseModel<any>>(
      this.apiUrl,
      body,
      httpOptions
    );
  }

    // intercompany transaction from Sales Return To Purchase Return
    fromSalesReturnToPurchaseReturn(payload:any, visa: ApiVisa): Observable<BasicApiResponseModel<any>> {
      if (this.endpoint_path && visa.api_domain_url) {
        this.apiUrl = visa.api_domain_url + this.endpoint_path + "/sales-return-to-purchase-return";
      }
      const httpOptions = {
        headers: new HttpHeaders({
          authorization: payload.authKey,
          tenantCode: payload.tenantCode,
          appId: payload.appletCode, 
        })
      }
  
      let body = {
        guids: payload.guids
      }
  
      return this.httpClient.post<BasicApiResponseModel<any>>(
        this.apiUrl,
        body,
        httpOptions
      );
    }

      // intercompany transaction from Payment Voucher To ReceiptVoucher
  fromPaymentVoucherToReceiptVoucher(payload:any, visa: ApiVisa): Observable<BasicApiResponseModel<any>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path + "/payment-voucher-to-receipt-voucher";
    }
    const httpOptions = {
      headers: new HttpHeaders({
        authorization: payload.authKey,
        tenantCode: payload.tenantCode,
        appId: payload.appletCode, 
      })
    }

    let body = {
      guids: payload.guids
    }

    return this.httpClient.post<BasicApiResponseModel<any>>(
      this.apiUrl,
      body,
      httpOptions
    );
  }
}
